<template>
  <div class="yypreach">
    <div class="nav-title" v-if="!isOpenInApp">
      <div class="back" @click="back"></div>
      <div class="title">理论宣讲应用平台</div>
    </div>
    <div class="info-container">
      <div class="info-item" v-for="item in infoList" :key="item.name">
        <div class="num">{{ item.val || 0 }}</div>
        <div class="text">{{ item.name }}</div>
      </div>
    </div>
    <div class="login-btn" @click="toYypreach">登录管理平台</div>
    <div class="tabs">
      <div
        :class="['tab-item', columnId === '50024' ? 'active' : '']"
        @click="columnId = '50024'"
      >
        活动预告
      </div>
      <div
        :class="['tab-item', columnId === '50025' ? 'active' : '']"
        @click="columnId = '50025'"
      >
        宣讲回顾
      </div>
    </div>
    <div style="padding: 0.2rem 0.3rem;">
      <div class="newslist">
        <van-list
          v-model="listLoading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="false"
          @load="onListLoad"
        >
          <div v-for="(item, i) in newsList" :key="i" @click="intoDetail(item)">
            <!-- 单图 listViewType 列表显示类型{0:无图,1:单图,2:大图,3:多图,4:轮播}-->
            <div v-if="item.listViewType == 1" class="newsitem-rightpic">
              <div class="newsitem-title">
                <div class="title">{{ item.title }}</div>
                <div class="time">
                  <div>
                    <!-- <span>{{ item.infoSource }}</span> -->
                    <span>浏览量{{ item.viewCount }}</span>
                  </div>
                  <div>
                    {{ item.onlineDate }}
                  </div>
                </div>
              </div>
              <div>
                <img :src="item.images" />
              </div>
            </div>
            <!-- 大图 -->
            <div v-else-if="item.listViewType == 2" class="newsitem-bigpic">
              <div class="newsitem-title">
                <div class="title">{{ item.title }}</div>
              </div>
              <div>
                <img class="newsitem-bigimg" :src="item.images" />
              </div>
              <div class="time">
                <div>
                  <!-- <span>{{ item.infoSource }}</span> -->
                  <span>浏览量{{ item.viewCount }}</span>
                </div>
                <div>
                  {{ item.onlineDate }}
                </div>
              </div>
            </div>
            <!-- 多图 -->
            <div v-else-if="item.listViewType == 3" class="newsitem-bigpic">
              <div class="newsitem-title">
                <div class="title">{{ item.title }}</div>
              </div>
              <div class="newsitem-moreimg">
                <img :src="item.images.split(';')[0]" />
                <img :src="item.images.split(';')[1]" />
                <img :src="item.images.split(';')[2]" />
              </div>
              <div class="time">
                <div>
                  <!-- <span>{{ item.infoSource }}</span> -->
                  <span>浏览量{{ item.viewCount }}</span>
                </div>
                <div>
                  {{ item.onlineDate }}
                </div>
              </div>
            </div>
            <!-- 无图 -->
            <div v-else class="newsitem-bigpic">
              <div class="newsitem-title">
                <div class="title">{{ item.title }}</div>
              </div>
              <div class="time">
                <div>
                  <!-- <span>{{ item.infoSource }}</span> -->
                  <span>浏览量{{ item.viewCount }}</span>
                </div>
                <div>
                  {{ item.onlineDate }}
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/api/index";
import { Loading, List } from "vant";
import Base64 from "@/common/base64.ts";

export default {
  name: "yypreachLlxjyypt",
  components: {
    [Loading.name]: Loading,
    [List.name]: List
  },
  data() {
    return {
      columnId: "50024",
      columnImg: [], // banner
      listLoading: true,
      finished: false,
      tabColumn: [], // 上面四个方块的list
      newColumn: [], // 下面新闻的list
      columnList: [],
      newsList: [], // 新闻列表
      infoList: [],
      isOpenInApp: true
    };
  },
  watch: {
    columnId() {
      this.newsList = [];
      this.getNewsList();
    }
  },
  mounted() {
    this.getNewsList(); // 初始化列表
    this.getJsonInfo();
    if (ZWY_CLOUD.isOpenInApp()) {
      this.isOpenInApp = true;
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowMoreBtn: 0,
        isShowTitle: "理论宣讲应用平台"
      });
    } else {
      document.title = "理论宣讲应用平台";
      this.isOpenInApp = false;
    }
  },
  methods: {
    getJsonInfo() {
      request
        .getLlxjptJson()
        .then(res => {
          this.infoList = res;
        })
        .catch(() => {
          this.infoList = [
            {
              name: "宣讲任务数",
              val: 0
            },
            {
              name: "宣讲员队伍数",
              val: 0
            },
            {
              name: "宣讲员人数",
              val: 0
            },
            {
              name: "宣讲阵地数",
              val: 0
            },
            {
              name: "宣讲作品数",
              val: 0
            },
            {
              name: "宣讲覆盖率",
              val: 0
            }
          ];
        });
    },
    getNewsList() {
      let lastId = "";
      let lastSortNo = "";
      let lastOnlineTime = "";
      if (this.newsList && this.newsList.length > 0) {
        let lastItem = this.newsList[this.newsList.length - 1];
        lastId = String(lastItem["id"]);
        lastSortNo = String(lastItem["sortNo"]);
        lastOnlineTime = String(lastItem["onlineTime"]);
      }
      request
        .getNewsList("40", this.columnId, lastId, lastSortNo, lastOnlineTime)
        .then(res => {
          if (res.code == 0 && res.data) {
            if (res.data.news.length < 10) {
              this.finished = true;
            }
            this.listLoading = false;
            this.newsList = this.newsList.concat(res.data.news);
          }
        });
    },
    back() {
      if (ZWY_CLOUD.isOpenInApp()) {
        ZWY_CLOUD.appCloseWeb();
      } else {
        window.location.href = "about:blank";
      }
    },
    toYypreach() {
      if (ZWY_CLOUD.isOpenInApp()) {
        ZWY_CLOUD.redirectUrl({
          id: "-1",
          isShowTop: "1",
          isShowBottom: "0",
          isShowMore: "0",
          url: "https://yypreach.cqliving.com/h5/login",
          title: Base64.encode("理论宣讲应用平台") //base 64
        });
        // window.open("https://yypreach.cqliving.com/h5/login");
      } else {
        window.location.href = "https://yypreach.cqliving.com/h5/login";
      }
    },
    intoDetail(item) {
      if (ZWY_CLOUD.isOpenInApp()) {
        ZWY_CLOUD.redirectUrl({
          id: item.id,
          sourceId: item.informationId,
          detailViewType: item.detailViewType,
          sourceType: item.sourceType,
          commentType: item.commentType,
          contextType: item.contextType,
          isShowTop: 1,
          isShowBottom: 1,
          isShowMore: 1,
          url: item.url,
          shareUrl: item.shareUrl,
          title: Base64.encode(item.title), //base 64
          synopsis: Base64.encode(item.synopsis), //base 64
          shareImgUrl: item.shareImgUrl
        });
      } else {
        window.location.href = item.url;
      }
    },
    onListLoad() {
      if (this.newsList.length == 0) {
        return;
      }
      this.getNewsList();
    }
  }
};
</script>

<style scoped="true" lang="scss">
.yypreach {
  background: #f5f9fb;
  font-family: PingFang SC;
  font-weight: 500;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.nav-title {
  background-color: #fff;
  height: 0.88rem;
  line-height: 0.88rem;
  position: relative;
  text-align: center;
  .back {
    width: 0.19rem;
    height: 0.33rem;
    background: url("~@/assets/yypreach/back_icon.png") no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0.3rem;
    bottom: 0.28rem;
  }
  .title {
    font-size: 0.4rem;
    color: #000000;
  }
}
.info-container {
  width: 7.25rem;
  height: 3.56rem;
  background: url("~@/assets/yypreach/info_bg.png") no-repeat;
  background-size: 100%;
  margin: 0.15rem auto 0.26rem;
  box-sizing: border-box;
  padding: 0.36rem 0.17rem;
  display: flex;
  flex-wrap: wrap;
  .info-item {
    height: 1.46rem;
    width: 2.23rem;
    color: #fff;
    position: relative;
    font-size: 0.28rem;
    color: #ffffff;
    text-align: center;
    padding-top: 0.3rem;
    box-sizing: border-box;
    .num {
      font-size: 0.36rem;
    }
    &:nth-of-type(2),
    &:nth-of-type(5) {
      &::before {
        content: " ";
        position: absolute;
        width: 0.01rem;
        height: 0.7rem;
        background: #fd8a8b;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &::after {
        content: " ";
        position: absolute;
        width: 0.01rem;
        height: 0.7rem;
        background: #fd8a8b;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    &:not(:nth-of-type(2)):not(:nth-of-type(5)) {
      width: 2.32rem;
    }
  }
}
.login-btn {
  width: 6.9rem;
  height: 0.92rem;
  line-height: 0.92rem;
  background: #d52122;
  border-radius: 0.46rem;
  font-weight: bold;
  font-size: 0.36rem;
  text-align: center;
  color: #fff;
  margin: 0 auto;
}
.tabs {
  margin-top: 0.4rem;
  height: 0.6rem;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 0.3rem;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;
  .tab-item {
    height: 100%;
    transition: all 0.3s;
    &:last-child {
      margin-left: 0.2rem;
    }
  }
  .active {
    font-weight: bold;
    font-size: 0.32rem;
    position: relative;
    &::after {
      width: 0.59rem;
      height: 0.07rem;
      background: #d42121;
      border-radius: 0.04rem;
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.newslist {
  box-sizing: border-box;
  background-color: #ffffff;
  padding: 0.3rem;
  font-size: 0.36rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 0.48rem;
  > div {
    > div {
      // border-bottom: 1px solid #eeeeee;
      // padding-bottom: 0.4rem;
      margin-top: 0.5rem;
    }
    > div:first-child {
      margin-top: 0;
    }
  }
  .time {
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #a0a0a0;
    line-height: 0.24rem;
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-top: 0.5rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  img {
    width: 1.8rem;
    height: 1.8rem;
    background: #a4a4a4;
    border-radius: 0.06rem;
  }
  .title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  .newsitem-rightpic {
    display: flex;
    align-content: center;
    justify-content: space-between;
    .newsitem-title {
      margin-right: 0.4rem;
    }
    // img{
    //   width: 2rem;
    //   height: 1.52rem;
    //   flex-shrink: 0;
    // }
  }
  span {
    margin-right: 0.1rem;
  }
  .newsitem-bigimg {
    width: 100%;
    height: 2.2rem;
    margin: 0.3rem 0 0 0;
  }
  .newsitem-moreimg {
    display: flex;
    justify-content: space-between;
    margin-top: 0.2rem;
    img {
      width: 2rem;
    }
  }
}
</style>
